import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import ImageBox from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const FormBox = styled(FlexDiv)`
  flex-direction: column;
  background-color: ${theme.colors.white};
  border-radius: 24px;
  overflow: hidden;
  width: 100%;
  border: 1px solid ${theme.colorsV2.blueGray.shade_100};
  box-shadow: 0px 10px 20px rgba(${theme.colors.shadows.black}, 0.04),
    0px 2px 6px rgba(${theme.colors.shadows.black}, 0.04),
    0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04);
`;

export const StyledBlueBox = styled(FlexDiv)`
  background-color: ${theme.colorsV2.shyft.purple_text};
  padding: 24px 32px;

  @media only screen and (max-width: 600px) {
    padding: 16px 32px;
  }
`;

export const StyledPartnerLogo = styled(ImageBox)`
  height: 30px;
  width: auto;
  object-fit: unset;
`;

export const LogoBox = styled(FlexDiv)`
  gap: 8px;
  align-items: center;
`;

export const StyledSeparator = styled(Box)`
  background-color: #ccc;
  height: 40px;
  width: 1px;
`;

export const StyledShyftLogo = styled(StyledSvgSprite)`
  fill: ${theme.colors.white};
  height: 24px;
  width: 55px;
`;

export const Title = styled(Typography)`
  color: ${theme.colors.white};
  font-size: 16px;
  line-height: 24px;
`;

export const Subtitle = styled(Typography)`
  color: ${theme.colors.white};
`;

export const StyledFormFieldBox = styled(FlexDiv)`
  flex-direction: column;
  padding: 24px;
`;
